function ClassificationFormCtrl($scope, $state, Upload) {

    $scope.datamodified = false;
    $scope.origItems = {};
    var $sideBar = $('#sidebar');
    var sideBarWidth = $sideBar.length > 0 ? ($sideBar.width() - 15) : 300;

    $scope.tableConfig = {
        searchDelay: 600,
        class: 'classification-table',
        editTable:true,
        select: function(item,field,id){
            $scope.selectedItem = item;
            $scope.classificationConfig.selectedItems = $scope.selectedItem.categories;
            $scope.$root.openPopup("addClassificationItem");
        },
        fields :[
            {"label":"Item","path":"item","template":"<input style='width:90%; margin-top: 9px; margin-left: 9px;' type='text' ng-attr-placeholder='Add Item' ng-model='item.item' class='search form-control' id='titleSearch-item.id'/>"},


            {"label":"Type","path":"classificationType","template":"<span>{{item.classificationType}}</span>"},
            {"label":"Classifications","path":"categories","template":"<entry-list items='item.categories' root='item' field='categories' id='classifications_{{$index}}' add-items='tableConfig.select(item,field,id)' mouseenterevent='tableConfig.mouseenter(item, pos)' mouseleaveevent='tableConfig.mouseleave(item)' icons='tableConfig.icons'></entry-list>"}
        ],
        titleSearch: 'Classification',
        searchVal: $state.params.searchVal || '',
        searchField: "item",
        sortList : [{sortField: "item", sortDir: "ASC" }],
        showLoader: true,
        actions: [],
        getStatus:function(item){
            if(!$scope.ignoreChanges){
                if(item.id < 0){
                    return "new";
                }
                var status = "saved";
                var origItem = $scope.origItems[item.id];
                if(origItem && !angular.equals(item,origItem)){
                    status = "changed";
                }
                item.status = status;
                return status;
            }
            else{
                return item.status;
            }
        },
        specialActions: [
               {
                   'icon': 'add',
                   'tooltip':'Add',
                   'func':  function(selectedItems,config) {
                       if(!config.items){
                           config.items = [];
                       }
                       var randomId = -1 * (Math.floor((Math.random() * 100000000000000) + 1));
                       config.items.unshift({"id": randomId, "item":"","classificationType":null, "categories" : []});
                   }
               },
               {
                   'icon':'delete',
                   'tooltip':'Delete',
                   'func' : function(selectedItems,config) {
                       $scope.removeItems(selectedItems,config);
                   }
               },
               {
                   'icon':'upload-file',
                   'tooltip':"Upload file",
                   'id':'btn-upload-file',
                   'func':function() {
                        $scope.cleanErrorList();
                        $scope.openUploadFileDlg();
                    }
               }
        ],
        processData : function(items){
            items.forEach(function(item){
                item.status = "saved";
                var classificationItems = [];
                if (!item.categories){
                    item.categories = [];
                }
                item.categories.forEach(function(classification) {
                    var classificationItem = {id: classification, category:classification, name:classification};
                    classificationItems.push(classificationItem);
                });
                item.categories = classificationItems;
            });
            var orig = angular.copy(items);
            orig.forEach(function(item){
                $scope.origItems[item.id] = item;
            });
        },
        fixedLayout: true,
        facets: [{"id": "type", label: "Type", order: 1},{"id": "classification", label: "Classification"}],
        facetsUrl: "/ag/getClassifications",
        selectedItems: [],
    };

    $scope.classificationConfig = {
    	dataURL: function () {
    		return '/getAllURLFilterCategories';
    	},
    	actions: [],
    	pageSize: 5,
    	titleSearch: true,
    	fixedLayout: true,
    	fields: [{ label: 'Name', template: '<span>{{item.display_name}}</span>', path: 'display_name' }],
    	selectedItems: [],
        sortField: "display_name",
    };

    $scope.hasChanges = function(){
        var rulesChanged = $("#classificationTable .warning:visible").length > 0;
        return rulesChanged;
    };

    $scope.removeItems = function(selectedItems,config){
        var len = selectedItems.length;
        if(len == 0) {
            $scope.$root.alert("Please select items to delete");
            return;
        }

        var itemsToDelete = [];
        selectedItems.forEach(function(item){
            itemsToDelete.push(item.id);
        });
        var itemsMessage = len == 1?"one rule": len + " rules";
        $scope.$root.confirm("Are you sure you want to remove " +  itemsMessage + "?", function(){
        	store.fetch({
        		path: '/ag/removeClassifications',
        		method: 'POST',
        		data: itemsToDelete,
                dataObj: 'classificationsList',
        		success: function (data) {
        			$scope.progress = data;
        			$scope.$root.handleServerResponse(data, "","Classification removed successfully");
        			if ($scope.progress.status != 'ERROR') {
        			    $scope.datamodified = new Date().getTime();
        			}
        		},
        	});
        });
    };

    $scope.addClassifications = function () {
        $scope.selectedItem.categories = [];
        $scope.classificationConfig.selectedItems.forEach(function(classification) {
            $scope.selectedItem.categories.push(classification);
        });
        $scope.$root.closePopup('addClassificationItem');
    };

    $scope.saveClassifications = function(){

            let changedItems = [];
            $scope.tableConfig.items.forEach(function(item) {
                if(item.status != 'saved'){
                    var changedItem = {id: item.id, item: item.item, categories:[]};
                    if (!item.categories){
                        item.categories = [];
                    }
                    item.categories.forEach(function(classification) {
                        changedItem.categories.push(classification.id);
                    });
                    changedItems.push(changedItem);
                }
            });

            $scope.loading = true;
            $scope.ignoreChanges = true;
            store.save({
                path: '/ag/saveClassifications',
                data: changedItems,
                dataObj: 'classificationsList',
                success: function (data) {
                $scope.ignoreChanges = false;
                    $scope.loading = false;
                    $scope.$root.handleServerResponse(data, '', 'Classifications saved successfully', null);
                    if (data.status !== 'ERROR') {
                        $scope.datamodified = new Date().getTime();
                    }
                },
            });
    };

	$scope.sendClassificationRequest = function() {
		if(!document.getElementById('filesInput').files || document.getElementById('filesInput').files.length == 0){
		    return;
		}
		var file = document.getElementById('filesInput').files[0];
		var files = (new Date()).getTime() + ".properties";

        Upload.upload({
            url: "/ag/uploadFile?fileName="+ files+ "&fileType=urlClassification&authenticityToken=" + store.authenticityToken,
            file: file
        }).progress(function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            console.log('progress: ' + progressPercentage + '% ' + evt.config.file.name);
        }).success(function (data, status, headers, config) {
            console.log('file ' + config.file.name + 'uploaded. Response: ' + data);
            store.fetch({
            	method : 'GET',
            	url : "/ag/loadClassificationFile?file=" + files + "&authenticityToken=" + authenticityToken ,
            	success: function(data) {
            	$scope.closeUploadFileDlg();
            	    $scope.handleServerResponse(data);
            	    $scope.datamodified = new Date().getTime();
            	}
            });
        });
	};

    $scope.handleServerResponse = function (response) {
        var isError = (response.status === 'ERROR');
        var notificationType = isError ? 'error' : 'success';
        var message;

        for (var key in response.notifications) {
            var notification = response.notifications[key];
            if(!notification.status){
                message = notification.message ;
            }
            else{
                if(!$scope.errorList){
                    $scope.errorList = [];
                }
                var arr = notification.field.split(".");
                if(arr.length > 2){
                    $scope.errorList.push({lineNumber: arr[1], field: arr[2] , message:notification.message});
                }
                else{
                    $scope.errorList.push(notification.message);
                }
            }
        }
        if($scope.errorList && message){
            $scope.errorList.splice(0, 0, message)
        }
        $scope.$root.showNotification(notificationType, message, '', isError);
    };

    $scope.openUploadFileDlg = function() {
        $scope.$emit("$openPopup","uploadFile","special-action-btn-upload-file" , {lockDown:true, leftMod: -sideBarWidth} );
        $('#btn-upload-file').addClass('open');
    };

    $scope.closeUploadFileDlg = function() {
        $scope.$emit("$closePopup","uploadFile");
        $('#btn-upload-file').removeClass('open');
    };

    $scope.cleanErrorList = function(){
        delete $scope.errorList;
    }

    /*
    WEBROOT USAGE STATS
    */

    $scope.webrootUsageType = ["MONTH", "QUARTER"];
    $scope.webrootUsageMonths = moment.months();
    $scope.webrootUsageYear = [2018, 2019, 2020, 2021, 2022];
    $scope.webrootStats = {};

    $scope.downloadWebrootStatsFile = function() {
         // download file
         window.location.href = '/downloadTrafficMonthlyStats?year=' + $scope.webrootStats.selectedYear + '&month=' + (moment().month($scope.webrootStats.selectedMonth).month() + 1) + '&usage=' + $scope.webrootStats.selectedUsage;
    };

}
